export default __webpack_public_path__ + "static/media/picyellow.558f3623.png";